__turbopack_context__.v({
  "divider": "nav-drawer-module-scss-module__c3NvjG__divider",
  "fullList": "nav-drawer-module-scss-module__c3NvjG__fullList",
  "link": "nav-drawer-module-scss-module__c3NvjG__link",
  "list": "nav-drawer-module-scss-module__c3NvjG__list",
});
